import { defaultHttpClient } from '../../httpClient';
import type { PocListResponse } from './types';

export const getPocList = async () => {
  return defaultHttpClient
    .request<PocListResponse>({
      method: 'GET',
      url: '/api/v2/members/me/poc/',
    })
    .then(result => result.data);
};
